import { Grid, Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux";
import { getCaseForReviewAction, selectAttempts, selectClaimType, selectQueueType } from "./QueueSlice";

interface SkipCaseModalProps {
  handleClose(): void;
}

export function SkipCaseModal(props: SkipCaseModalProps) {
  const { handleClose } = props;

  const queueType = useAppSelector(selectQueueType);
  const claimType = useAppSelector(selectClaimType);
  const attempts = useAppSelector(selectAttempts);

  const dispatch = useAppDispatch();

  const nextCase = async () => {
    if (!queueType) return;
    const _queueType = queueType === "paneem" ? queueType : "SP";

    const args = {
      queueType: _queueType,
      claimType: claimType as string,
      userInfoId: !attempts ? null : attempts[0].details.userInfoId,
      regNum: !attempts ? null : attempts[0].info.Registration_Number,
    };
    await dispatch(getCaseForReviewAction(args));
  };
  return (
    <>
      <Grid container textAlign={"center"}>
        <Grid item xs={6} xl={6} textAlign={"center"}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        </Grid>
        <Grid item xs={6} xl={6} textAlign={"center"}>
          <Button
            variant="contained"
            onClick={() => {
              nextCase();
              handleClose();
            }}
          >
            Proceed
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
